import React from 'react';
import { DeleteOutlined } from '@ant-design/icons';

type DeleteButtonProps = {
  onClick: () => void,
};

export const DeleteButton = ({ onClick }: DeleteButtonProps) => {
  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    onClick();
  };

  return (
    <DeleteOutlined onClick={handleClick} />
  );
};
